const cards = document.querySelectorAll('.m-card')
if (cards.length > 0) {
  cards.forEach( c => {
    c.style.cursor = 'pointer'
    let url = c.querySelector('a').href
    c.addEventListener('click', function(){
      window.location = url
    })
  })
}